var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 493,
    height: 228,
    viewBox: "0 0 493 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-29.6575 192.177C-1.8513 283.962 136.457 323.297 279.263 280.035C422.069 236.772 515.294 127.294 487.488 35.5083C459.682 -56.2771 367.144 55.4717 224.338 98.7345C81.5326 141.997 -57.4637 100.391 -29.6575 192.177Z",
    fill: "#4772F1",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse23);
export default __webpack_public_path__ + "static/media/Ellipse 23.ee11264b6dbf96d31d58f966c430028b.svg";
export { ForwardRef as ReactComponent };